import { Dropdown } from "pepsico-ds";
import DateTimePickerWithTimeZone from "../../common/DateTime/DateTimePickerWithTimeZone";
import { CONTEXT_TYPE, FILE_STATUS } from "../utils/fileManagerConstants";
import "./FileManagerFilters.scss";

const statusOptions = [
  { displayText: "Pending", id: FILE_STATUS.PENDING },
  { displayText: "Processing", id: FILE_STATUS.PROCESSING },
  { displayText: "Completed", id: FILE_STATUS.COMPLETED },
  { displayText: "Failed", id: FILE_STATUS.FAILED },
  { displayText: "Expired", id: FILE_STATUS.EXPIRED },
  { displayText: "In Process", id: FILE_STATUS.IN_PROCESS },
  { displayText: "Processed", id: FILE_STATUS.PROCESSED },
  { displayText: "Uploaded", id: FILE_STATUS.UPLOADED },
];

const contextOptions = CONTEXT_TYPE.map((ctx) => ({
  displayText: ctx.text,
  id: ctx.key,
}));

export default function FileManagerFilters({
  filterRef,
  onChangeFilters,
  programTimezone = "America/Chicago",
  className = "",
}) {
  const emit = () => onChangeFilters?.();

  const handleStatus = (v) => {
    filterRef.current.status = v;
    emit();
  };

  const handleContext = (v) => {
    filterRef.current.context = v;
    emit();
  };

  const handleFromDate = (date) => {
    filterRef.current.fromDate = date ? new Date(date).toISOString() : "";
    emit();
  };

  const handleToDate = (date) => {
    filterRef.current.toDate = date ? new Date(date).toISOString() : "";
    emit();
  };

  const handleClearAll = () => {
    filterRef.current = {
      status: "",
      context: "",
      fromDate: "",
      toDate: "",
    };
    emit();
  };

  return (
    <div className={`file-manager-filters-container ${className}`}>
      <div className="filter-wrapper">
        <Dropdown
          childList={statusOptions}
          selection="single"
          selectedValue={filterRef.current.status}
          placeholder="Status"
          size="medium"
          className="filter-dropdown dropdown-segment"
          setSelectedValue={handleStatus}
        />
        <Dropdown
          childList={contextOptions}
          selection="single"
          selectedValue={filterRef.current.context}
          placeholder="Context"
          size="medium"
          className="filter-dropdown dropdown-segment"
          setSelectedValue={handleContext}
        />
        <DateTimePickerWithTimeZone
          label="From date"
          dateTime={filterRef.current.fromDate}
          setDateTime={handleFromDate}
          timezone={programTimezone}
          slotProps={{
            actionBar: {
              actions: ["clear", "accept"],
            },
          }}
          className="filter-dropdown dropdown-segment date-picker"
        />
        <DateTimePickerWithTimeZone
          label="To date"
          dateTime={filterRef.current.toDate}
          setDateTime={handleToDate}
          timezone={programTimezone}
          slotProps={{
            actionBar: {
              actions: ["clear", "accept"],
            },
          }}
          disabled={false}
          className="filter-dropdown dropdown-segment date-picker"
        />
        <div
          className="clear-all-btn"
          onClick={handleClearAll}
          role="button"
          tabIndex="0"
        >
          Clear All
        </div>
      </div>
    </div>
  );
}
